/* eslint-disable jsx-a11y/label-has-associated-control, max-len */
import './GlobeDarkmodeButton.scss';

import PropTypes from 'prop-types';

const GlobeDarkmodeButton = ({ checked, setDarkmode }) => {
  return (
    <label className="gw-globe-darkmode-switch">
      <input
        className="gw-globe-darkmode-switch__input"
        type="checkbox"
        role="switch"
        checked={checked}
        onChange={
          setDarkmode ? () => setDarkmode((state) => !state) : undefined
        }
      />
      <div className="gw-globe-darkmode-switch__dark-icon-container">
        <svg
          className="gw-globe-darkmode-switch__icon--dark"
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          aria-hidden="true"
        >
          <path
            d="M17.4695 16.0169C12.2513 16.0169 8.02321 11.7887 8.02321 6.57062C8.02321 5.00312 8.41509 3.525 9.08884 2.21875C5.06009 3.29813 2.09009 6.9625 2.09009 11.335C2.09009 16.5531 6.31821 20.7812 11.5363 20.7812C15.187 20.7812 18.3426 18.7119 19.917 15.6869C19.1401 15.8931 18.322 16.0169 17.4763 16.0169H17.4695Z"
            strokeMiterlimit="10"
          />
        </svg>
      </div>
      <div className="gw-globe-darkmode-switch__light-icon-container">
        <svg
          className="gw-globe-darkmode-switch__icon--light"
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M11 15.125C13.2782 15.125 15.125 13.2782 15.125 11C15.125 8.72183 13.2782 6.875 11 6.875C8.72183 6.875 6.875 8.72183 6.875 11C6.875 13.2782 8.72183 15.125 11 15.125Z"
            strokeMiterlimit="10"
          />
          <path d="M11 17.1875V20.2812" strokeMiterlimit="10" />
          <path d="M11 1.71875V4.8125" strokeMiterlimit="10" />
          <path d="M4.8125 11H1.71875" strokeMiterlimit="10" />
          <path d="M20.2812 11H17.1875" strokeMiterlimit="10" />
          <path d="M6.62745 15.3726L4.43433 17.5657" strokeMiterlimit="10" />
          <path d="M17.5657 4.43433L15.3726 6.62745" strokeMiterlimit="10" />
          <path d="M6.62745 6.62745L4.43433 4.43433" strokeMiterlimit="10" />
          <path d="M17.5657 17.5657L15.3726 15.3726" strokeMiterlimit="10" />
        </svg>
      </div>
      <span className="gw-globe-darkmode-switch__sr">
        Toggle between light and dark mode
      </span>
    </label>
  );
};

GlobeDarkmodeButton.propTypes = {
  checked: PropTypes.bool,
  setDarkmode: PropTypes.func,
};

GlobeDarkmodeButton.defaultProps = {
  checked: false,
  setDarkmode: undefined,
};

export default GlobeDarkmodeButton;
